import React, { useState } from "react";
import closeBtn from "../../assets/svg/free-icon-minimize-sign-6057365 2.svg";
import arrow from "../../assets/svg/arrow.svg";

const CoWorkers = ({ changeIsEditingForm }) => {
  // Left Section: Organization Details
  const [legalForm, setLegalForm] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  const [shortName, setShortName] = useState("");
  const [address, setAddress] = useState("");
  const [inn, setInn] = useState("");
  const [kpp, setKpp] = useState("");
  const [okpo, setOkpo] = useState("");
  const [ogrn, setOgrn] = useState("");
  const [date, setDate] = useState("");
  const [liquidationDate, setLiquidationDate] = useState("");
  const [deliveryAddress, setDeliveryAddress] = useState("");
  const [taxScheme, setTaxScheme] = useState("");
  const [responsiblePerson, setResponsiblePerson] = useState("");
  const [basisOfAuthority, setBasisOfAuthority] = useState("");
  const [bank, setBank] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [phone1, setPhone1] = useState("");
  const [phone2, setPhone2] = useState("");
  const [phone3, setPhone3] = useState("");

  // Right Section: Buyer and Document Details
  const [city, setCity] = useState("");
  const [manager, setManager] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [status, setStatus] = useState("");
  const [department, setDepartment] = useState("");
  const [edoOperatorName, setEdoOperatorName] = useState("");
  const [edoOperatorCode, setEdoOperatorCode] = useState("");
  const [edoInnOperator, setEdoInnOperator] = useState("");
  const [archiveStatus, setArchiveStatus] = useState("");
  const [externalNumber, setExternalNumber] = useState("");
  const [comment, setComment] = useState("");
  const handleSubmit = (e) => {};

  return (
    <div className="overlay">
      <div className="form-container editingForm">
        {/* Editable from here */}
        <h2 className="header">Редактирование компании</h2>
        <form onSubmit={handleSubmit} className="">
          <div className="form-inner__container">
            <div className="form-container__left">
              {/* --- row1 --- */}
              <div className="row">
                <div className="form-group">
                  <label className="label">Правовая форма</label>
                  <input
                    type="text"
                    placeholder="ООО"
                    value={legalForm}
                    onChange={(e) => setLegalForm(e.target.value)}
                    className="input"
                  />
                </div>
                <div className="form-group">
                  <label className="label">Наименование организации</label>
                  <input
                    type="text"
                    placeholder="“АВА СИСТЕМЫ”"
                    value={organizationName}
                    onChange={(e) => setOrganizationName(e.target.value)}
                    className="input"
                  />
                </div>
                <div className="form-group">
                  <label className="label">Сокращенное наименование</label>
                  <input
                    type="text"
                    placeholder="“АВА СИСТЕМЫ”"
                    value={shortName}
                    onChange={(e) => setShortName(e.target.value)}
                    className="input"
                  />
                </div>
              </div>
              {/* --- row2 --- */}
              <div className="row">
                <div className="form-group">
                  <label className="label">Адрес</label>
                  <input
                    type="text"
                    placeholder="125599, г.Москва, Дмитровский р-н, МКАД 78-й км, д 14, к 1"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    className="input"
                  />
                </div>
              </div>
              {/* --- row3 --- */}
              <div className="row">
                <div className="form-group">
                  <label className="label">ИНН</label>
                  <input
                    type="text"
                    placeholder="1231231234"
                    value={inn}
                    onChange={(e) => setInn(e.target.value)}
                    className="input"
                  />
                </div>
                <div className="form-group">
                  <label className="label">КПП</label>
                  <input
                    type="text"
                    placeholder="12312312342"
                    value={kpp}
                    onChange={(e) => setKpp(e.target.value)}
                    className="input"
                  />
                </div>
                <div className="form-group">
                  <label className="label">ОКПО</label>
                  <input
                    type="text"
                    placeholder="12345"
                    value={okpo}
                    onChange={(e) => setOkpo(e.target.value)}
                    className="input"
                  />
                </div>
                <div className="form-group">
                  <label className="label">ОГРН</label>
                  <input
                    type="text"
                    placeholder="1111111111111"
                    value={ogrn}
                    onChange={(e) => setOgrn(e.target.value)}
                    className="input"
                  />
                </div>
              </div>
              {/* --- row4 --- */}
              <div className="row">
                <div className="form-group">
                  <label className="label">Дата</label>
                  <input
                    type="date"
                    placeholder="__.__.____"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                    className="input"
                  />
                </div>
                <div className="form-group">
                  <label className="label">Дата ликвидации</label>
                  <input
                    type="date"
                    placeholder="__.__.____"
                    value={liquidationDate}
                    onChange={(e) => setLiquidationDate(e.target.value)}
                    className="input"
                  />
                </div>
              </div>
              {/* --- row5 --- */}
              <div className="row">
                <div className="form-group">
                  <label className="label">Печатать адрес</label>
                  <select
                    className="input"
                    value={deliveryAddress}
                    onChange={(e) => setDeliveryAddress(e.target.value)}
                  >
                    <option value="" disabled>
                      123456789
                    </option>
                    <option value="option1">Option 1</option>
                    <option value="option2">Option 2</option>
                    <option value="option3">Option 3</option>
                  </select>
                </div>
                <div className="form-group">
                  <label className="label">Схема налогооблажения</label>
                  {/* <input
                    type="select"
                    placeholder="Обычная"
                    value={taxScheme}
                    onChange={(e) => setTaxScheme(e.target.value)}
                    className="input"
                  /> */}
                  <select
                    className="input"
                    value={taxScheme}
                    onChange={(e) => setTaxScheme(e.target.value)}
                  >
                    <option value="" disabled>
                      Обычная
                    </option>
                    <option value="option1">Option 1</option>
                    <option value="option2">Option 2</option>
                    <option value="option3">Option 3</option>
                  </select>
                </div>
              </div>
              {/* --- row6 --- */}
              <div className="row">
                <div className="form-group">
                  <label className="label">Ответственный</label>
                  <input
                    type="text"
                    placeholder="Попов А.Я."
                    value={responsiblePerson}
                    onChange={(e) => setResponsiblePerson(e.target.value)}
                    className="input"
                  />
                </div>
                <div className="form-group">
                  <label className="label">Действует на основании</label>
                  <input
                    type="text"
                    placeholder="Устава"
                    value={basisOfAuthority}
                    onChange={(e) => setBasisOfAuthority(e.target.value)}
                    className="input"
                  />
                </div>
              </div>
              {/* --- row7 --- */}
              <div className="row">
                <div className="form-group">
                  <label className="label">Банк</label>
                  <input
                    type="text"
                    placeholder="ПАО РОСБАНК 11111101"
                    value={bank}
                    onChange={(e) => setBank(e.target.value)}
                    className="input"
                  />
                </div>
                <div className="form-group">
                  <label className="label">Расчетный счет</label>
                  <input
                    type="text"
                    placeholder="123456789123456789123456789"
                    value={accountNumber}
                    onChange={(e) => setAccountNumber(e.target.value)}
                    className="input"
                  />
                </div>
              </div>
              {/* --- row8 --- */}
              <div className="row">
                <div className="form-group">
                  <label className="label">Телефон</label>
                  <input
                    type="phone"
                    placeholder="+7 (999) 999-99-99"
                    value={phone1}
                    onChange={(e) => setPhone1(e.target.value)}
                    className="input"
                  />
                </div>
                <div className="form-group">
                  <label className="label">Телефон</label>
                  <input
                    type="phone"
                    placeholder="+7 (___) ___-__-__"
                    value={phone2}
                    onChange={(e) => setPhone2(e.target.value)}
                    className="input"
                  />
                </div>
                <div className="form-group">
                  <label className="label">Телефон</label>
                  <input
                    type="phone"
                    placeholder="+7 (___) ___-__-__"
                    value={phone3}
                    onChange={(e) => setPhone3(e.target.value)}
                    className="input"
                  />
                </div>
              </div>
            </div>
            <div className="form-container__devider"></div>
            <div className="form-container__right">
              {/* --- row9 --- */}
              <div className="row">
                <div className="form-group">
                  <label className="label">Город</label>
                  <input
                    type="text"
                    placeholder=""
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                    className="input"
                  />
                </div>
                <div className="form-group">
                  <label className="label">Менеджер</label>
                  <input
                    type="text"
                    placeholder="Попов А.Я."
                    value={manager}
                    onChange={(e) => setManager(e.target.value)}
                    className="input"
                  />
                </div>
              </div>
              {/* --- row10 --- */}
              <div className="row">
                <div className="form-group">
                  <label className="label">Организация</label>
                  <input
                    type="text"
                    placeholder="Наш компания"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                    className="input"
                  />
                </div>
                <div className="form-group">
                  <label className="label">Состояние</label>
                  <input
                    type="text"
                    placeholder="Выписано"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    className="input"
                  />
                </div>
                <div className="form-group">
                  <label className="label">Отдел</label>
                  <input
                    type="text"
                    placeholder="Отдел технической"
                    value={department}
                    onChange={(e) => setDepartment(e.target.value)}
                    className="input"
                  />
                </div>
              </div>

              <div className="rows-container">
                <h1 className="rows-container__title">Покупатель</h1>
                {/* --- row11 --- */}
                <div className="row">
                  <div className="form-group">
                    <label className="label">ЭДО. Наименование оператора</label>
                    <input
                      type="text"
                      placeholder="АО ПФ СКБ Контур"
                      value={edoOperatorName}
                      onChange={(e) => setEdoOperatorName(e.target.value)}
                      className="input"
                    />
                  </div>
                  <div className="form-group">
                    <label className="label">ЭДО. Код оператора</label>
                    <input
                      type="text"
                      placeholder="2ВМ"
                      value={edoOperatorCode}
                      onChange={(e) => setEdoOperatorCode(e.target.value)}
                      className="input"
                    />
                  </div>
                  <div className="form-group">
                    <label className="label">ЭДО. ИНН оператора</label>
                    <input
                      type="text"
                      placeholder="1111111111111"
                      value={edoInnOperator}
                      onChange={(e) => setEdoInnOperator(e.target.value)}
                      className="input"
                    />
                  </div>
                </div>
                {/* --- row12 --- */}
                <div className="row">
                  <div className="form-group">
                    <label className="label">Архивность</label>
                    <select
                      className="input"
                      value={archiveStatus}
                      onChange={(e) => setArchiveStatus(e.target.value)}
                    >
                      <option value="" disabled>
                        Архивность
                      </option>
                      <option value="option1">Не архивный</option>
                      <option value="option2">Архивный</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="label">Внешние: №</label>
                    <input
                      type="text"
                      placeholder=""
                      value={edoOperatorCode}
                      onChange={(e) => setEdoOperatorCode(e.target.value)}
                      className="input"
                    />
                  </div>
                </div>
                <label htmlFor="comment" className="label">
                  Комментарий
                </label>
                <textarea
                  placeholder="Что-то очень важное"
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  name="comment"
                  id=""
                  className="textarea"
                ></textarea>
              </div>
            </div>
          </div>

          {/* Editable till here */}
          <button type="submit" className="btn popPasswordBtn">
            Сохранить
          </button>
        </form>

        <div className="closeForm">
          <button
            className="closePasswordFormBtn"
            onClick={changeIsEditingForm}
          >
            <img src={closeBtn} alt="CloseBtn" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CoWorkers;
